import UserGroupNodeRenderer from "../../hierarchySelector/userSelector/UserGroupNodeRenderer";
import {disableTextSelection} from '../../atBrowserUtils'

export default class UserGroupWithoutCheckboxNodeRenderer extends UserGroupNodeRenderer {

    generateContent(treeNode, targetEl) {
        let tableEl = document.createElement("table");
        let tBodyEl = document.createElement("tbody");
        let trEl = document.createElement("tr");
        let titleTdEl = document.createElement("td");
        let collapseTdEl = document.createElement("td");

        //visibility of this buttons are maintained by css
        let normalExpandCollapseButton = this.generateExpandCollapseButton(treeNode, true, "normalExpandCollapseButton", null);
        let disabledExpandCollapseButtonWithTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithTitle",
            this.getExpandCollapseButtonTitle(treeNode));
        let disabledExpandCollapseButtonWithoutTitle = this.generateExpandCollapseButton(treeNode, false, "disabledExpandCollapseButtonWithoutTitle", null);

        tableEl.appendChild(tBodyEl);
        tBodyEl.appendChild(trEl);
        trEl.appendChild(titleTdEl);
        trEl.appendChild(collapseTdEl);
        collapseTdEl.appendChild(normalExpandCollapseButton);
        collapseTdEl.appendChild(disabledExpandCollapseButtonWithTitle);
        collapseTdEl.appendChild(disabledExpandCollapseButtonWithoutTitle);

        let spacerDiv = document.createElement("div");
        spacerDiv.className = "spacer";
        spacerDiv.innerHTML = "<b></b>"; // for IE to display correctly

        targetEl.appendChild(tableEl);
        targetEl.appendChild(spacerDiv);

        let titleNode = document.createElement("a");
        titleNode.className = "titleNode";
        titleNode.hidefocus = "true";

        disableTextSelection(titleNode);

        let labelEl = document.createElement("span");
        labelEl.className = "ellipsisLabel";
        this.generateLabel(treeNode, labelEl);

        titleTdEl.appendChild(titleNode);
        titleNode.appendChild(labelEl);

        this.tree.getUIObjectForNode(treeNode).cbEl = titleNode;
        this.tree.getUIObjectForNode(treeNode).labelEl = labelEl;
    }
}




// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/UserGroupWithoutCheckboxNodeRenderer.js